import { createSlice } from "@reduxjs/toolkit";
import { V2Protocol } from "../types/timingFeed";
import { mergeObjectsV2, removeNulls, revertReplaceNulls } from "../utils";

const initialState = {
  v2: {} as V2Protocol,
  v2ConnectedState: {
    connected: false,
    connectionType: null,
    retrying: false,
    directConnectionParams: {
      host: "",
      port: 0,
      username: "",
      password: "",
    },
    activeReceiver: null,
    connectedReceivers: [] as string[],
    analytics: {
      connectedTime: null,
      resetTime: null,
      totalMessages: null,
    },
  },
};

export const aksSlice = createSlice({
  name: "aks",
  initialState,
  reducers: {
    setV2Data: (state, action) => {
      state.v2 = action.payload;
    },
    combineV2Data: (state, action) => {
      if (!action.payload) return;
      const copy = JSON.parse(JSON.stringify(action.payload));
      if (copy.timing === "NULL") {
        console.log("V2 data reset");
        state.v2 = {};
      } else {
        removeNulls(copy);
        revertReplaceNulls(copy);
        mergeObjectsV2(state.v2, copy);
      }
    },
    setV2ConnectedState: (state, action) => {
      if (!action.payload) return;
      if (action.payload.connected !== null) {
        state.v2ConnectedState.connected = action.payload.connected;
      }
      if (action.payload.connectionType !== null) {
        state.v2ConnectedState.connectionType = action.payload.connectionType;
      }
      if (action.payload.retrying !== null) {
        state.v2ConnectedState.retrying = action.payload.retrying;
      }
      if (action.payload.directConnectionParams !== null) {
        state.v2ConnectedState.directConnectionParams =
          action.payload.directConnectionParams;
      }
      if (action.payload.activeReceiver !== null) {
        state.v2ConnectedState.activeReceiver = action.payload.activeReceiver;
      }
      if (action.payload.connectedReceivers !== null) {
        state.v2ConnectedState.connectedReceivers =
          action.payload.connectedReceivers;
      }
      if (action.payload.analytics !== null) {
        if (action.payload.analytics.connectedTime !== null) {
          state.v2ConnectedState.analytics.connectedTime =
            action.payload.analytics.connectedTime === 0
              ? null
              : action.payload.analytics.connectedTime;
        }
        if (action.payload.analytics.totalMessages !== null) {
          state.v2ConnectedState.analytics.totalMessages =
            action.payload.analytics.totalMessages;
        }
        if (action.payload.analytics.resetTime !== null) {
          state.v2ConnectedState.analytics.resetTime =
            action.payload.analytics.resetTime === 0
              ? null
              : action.payload.analytics.resetTime;
        }
      }
    },
  },
});

export const { setV2Data, combineV2Data, setV2ConnectedState } =
  aksSlice.actions;
export default aksSlice.reducer;
